export default __webpack_public_path__ + "static/selapp-joy-mobile-53ee028230e794c68d6c1ee732a1e847.jpg";